module.exports = __webpack_public_path__ + "static/media/GillSans.12723286.ttc";